import React, { createElement, useEffect } from 'react';
import { Routes, Route, useLocation, Navigate } from 'react-router-dom';
import { ROUTES } from '@constants/routes';

const CustomRoutes: React.FC = () => {
  const location = useLocation();

  useEffect(() => {
    const path = location.pathname;

    switch (path) {
      case '/member-verification':
        document.title = 'Member Verification';
        break;
      case '/costco-subscription':
        document.title = 'Costco Subscription';
        break;
      case '/admin-dashboard':
        document.title = 'Admin Dashboard';
        break;
      case '/mvt/callback':
        document.title = 'Costco Callback';
        break;
      case '/not-authorized':
        document.title = 'Not Authorized';
        break;
      default:
        break;
    }
  }, [location.pathname]);

  return (
    <Routes>
      <Route
        path="/"
        element={<Navigate to="/member-verification" replace />}
      />
      {ROUTES.map((route) => (
        <Route
          key={route.key}
          path={route.path}
          element={createElement(route.element)}
        />
      ))}
    </Routes>
  );
};

export default CustomRoutes;
